import React from "react";
import CommonButton from "../../../Components/commonButton/commonButton";
import Api from "../../../services/api";
import Alert from "../../../Components/alert/Alert";
import ReadOnlyTextField from "../../../Components/readOnlyTextField/readOnlyTextField";
import Select from "../../../Components/select/select";
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";
import '../general.css'

export default class DelMachine extends React.Component {
  state = {
    description: "",
    code: null,
    work_shifts: [],
    department: null,
    show: false,
    message: "",
    oeeGoal: null,
    machines: [],
    id_machine: null,
    machinesAllProperties: [],
    id_work_shifts: [],
    work_shifts: [],
    work_shiftsString: null,
    notification: false,
    notification_type: 'success',
    notification_message: ''
  };

  componentDidMount() {
    Api.get("/machines/").then((resp) => {
      let arr = [];

      resp.data.forEach((element) => {
        arr.push({
          value: element.id,
          label: element.description + element.code,
        });
      });
      this.setState({ machines: arr, machinesAllProperties: resp.data });
    });
    Api.get("/work-shifts/").then((res) => {
      this.setState({ work_shifts: [...res.data] });
    });
  }

  CallbackMachine = async (childData) => {
    const { description, code, oee_goal, department, work_shifts } =
      this.state.machinesAllProperties.find((value) => value.id === childData);

    let arr = [];
    work_shifts.forEach((value) => {
      let { code } = this.state.work_shifts.find(
        (element) => element.id === value
      );
      arr.push(code);
    });
    this.setState({
      description: description,
      code: code,
      oeeGoal: oee_goal,
      department: department,
      work_shiftsString: arr,
      id_machine: childData,

    });
  };

  sendData = async () => {
    let { id_machine } = this.state;
    if (id_machine !== null) {
      Api.delete(`/machines/${id_machine}`)
        .then(async () => {

          this.setState({notification: true, notification_message: "Máquina deletada com sucesso!"});
          setTimeout(()=>{
            return window.location.reload();
          },2000)
        })
        .catch((error) => {
          if(error.response.status == 401){
            this.setState({ message: "Erro ao deletar! Um item depende desse registro.", show: true });
          }else{
            this.setState({ message: "Erro de conexão.", show: true });
          }
          
        });
    } else {
      this.setState({
        message: "Necessário preencher todos os campos.",
        show: true,
      });
    }
  };
  callbackfunction = () => {
    this.setState({ show: false });
  };

  render() {
    let { show, message, machines, notification, notification_message, notification_type } = this.state;
    return (
      <div className="box">
        {notification == true ? (<><Notification message={notification_message} type={notification_type}></Notification><Loading></Loading></>) : (<></>)}
        <div className="input_fields_del_machine form">
        <h4>Deletar Máquina</h4>
          <div className="inputs">
          {this.state.show ? (
            <Alert
              show={show}
              message={message}
              parentCallback={this.callbackfunction}
            />
          ) : null}
          <div className="selectDelMachine element">
            <Select
              autoSelect={true}
              label={"Máquinas"}
              arrData={machines}
              handleSelect={this.CallbackMachine}
            />
          </div>
          <div className="tf1DelMachine element">
            <ReadOnlyTextField
              title="Descrição"
              showValue={this.state.description}
            />
          </div>
          <div className="tf2DelMachine element">
            <ReadOnlyTextField title="Código" showValue={this.state.code} />
          </div>
          <div className="tf3DelMachine element">
            <ReadOnlyTextField
              title="Setor"
              showValue={this.state.department}
            />
          </div>
          <div className="tf4DelMachine element">
            <ReadOnlyTextField
              title="Turnos"
              showValue={this.state.work_shiftsString}
            />
          </div>
          <div className="tf5DelMachine element">
            <ReadOnlyTextField
              title="Meta OEE"
              showValue={this.state.oeeGoal}
            />
          </div>
          </div>
          <div className="btnDelMachine submitButton">
            <CommonButton title="Excluir" parentCallback={this.sendData} />
          </div>
        </div>
      </div>
    );
  }
}
